import { Center, Container, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import Header from '../../components/Header/index.jsx';
import { VERSION_APP } from '../../services/version.js';

FormLayoutProvider.propTypes = {
    children: PropTypes.node,
};

function FormLayoutProvider({ children }) {
    return (
        <Center minHeight='100vh'>
            <Container maxWidth='xl'>
                <Flex justifyContent='space-between' alignItems='center'>
                    v{VERSION_APP}
                </Flex>
                <Header />
                {children}
            </Container>
        </Center>
    );
}

export default FormLayoutProvider;
